import MaInput from "../../../../Components/UI/ma-input";
import { HiOutlineLightBulb } from "react-icons/hi";

const REQ = (
  <span className="text-red-500" aria-hidden>
    {" "}
    *
  </span>
);

export function AddProductStepPrice({
  price,
  onPriceChange,
  stock,
  onStockChange,
  lowStockAlert,
  onLowStockAlertChange,
  weight,
  onWeightChange,
  deliveryTime,
  onDeliveryTimeChange,
}) {
  return (
    <div className="flex flex-col gap-5 sm:gap-6">
      <div
        style={{ borderBottom: "1px solid #EAEAEA" }}
        className="px-4 pb-3 pt-4 sm:px-5 md:px-8 md:pt-0"
      >
        <h2 className="my-0 text-[16px] font-semibold text-[#1F2937] sm:text-[18px]">
          Price &amp; Inventory
        </h2>
        <p className="my-0 mt-1 text-[13px] text-[#6B7280]">
          Amount, stock, and fulfillment details.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 px-4 sm:px-5 md:grid-cols-2 md:px-8">
        <MaInput
          label={
            <span>
              Price ($)
              {REQ}
            </span>
          }
          fullWidth
          placeholder="$0"
          value={price}
          onChange={(e) => onPriceChange(e.target.value)}
          borderColor="#DADADA"
        />
        <MaInput
          label="Stock Quantity"
          fullWidth
          placeholder="0"
          value={stock}
          onChange={(e) => onStockChange(e.target.value)}
          borderColor="#DADADA"
        />
        <MaInput
          label={
            <span>
              Low Stock Alert
              {REQ}
            </span>
          }
          fullWidth
          placeholder="0"
          value={lowStockAlert}
          onChange={(e) => onLowStockAlertChange(e.target.value)}
          borderColor="#DADADA"
        />
        <MaInput
          label="Weight (kg)"
          fullWidth
          placeholder="0"
          value={weight}
          onChange={(e) => onWeightChange(e.target.value)}
          borderColor="#DADADA"
        />
      </div>

      <div className="px-4 pb-4 sm:px-5 md:px-8 md:pb-6">
        <MaInput
          label={
            <span>
              Delivery Processing Time
              {REQ}
            </span>
          }
          fullWidth
          placeholder="e.g. 2 (days as a number)"
          value={deliveryTime}
          onChange={(e) => onDeliveryTimeChange(e.target.value)}
          borderColor="#DADADA"
        />
        <p className="mt-1 text-[12px] text-[#9CA3AF]">
          Use a number only (e.g. 2 or 1.5). Text like &quot;2 days&quot; is read as 2.
        </p>
        <div className="flex gap-3 rounded-xl bg-[#EBEEF1] px-4 py-3 mt-3">
          <HiOutlineLightBulb
            className="mt-0.5 shrink-0 text-[22px] text-amber-500"
            aria-hidden
          />
          <p className="my-0 text-[12px] leading-relaxed text-[#3D3D3D]">
            <b>Listing will be reviewed within 24–48 hours.</b>
            <br /> You&apos;ll be notified once it&apos;s approved or if changes
            are required.
          </p>
        </div>
      </div>
    </div>
  );
}
